import React from "react"

import GoogleMap from "google-map-react"
import { pin, pulse } from "./pin.module.css"

const Marker = () => {
  return (
    <>
      <div className={ pin }></div>
      <div className={ pulse }></div>
    </>
  )
}

export const GoogleMapEL = props => {
  const { center, setCenter, zoom } = props

  let gridData

  const createMapOptions = () => {
    return {
      panControl: true,
      scrollwheel: true,
      scaleControl: true,
      mapTypeControl: false,
      zoomControl: false,
      fullscreenControl: false,
      styles: [
        {
          stylers: [ { saturation: -80 } ],
        },
        {
          featureType: "poi.business",
          stylers: [ { visibility: "off" } ],
        },
        {
          featureType: "transit",
          elementType: "labels.icon",
          stylers: [ { visibility: "off" } ],
        },
        {
          stylers: [
            {
              visible: true,
              strokeColor: "#777",
              strokeWeight: 0.5,
              clickable: false,
            },
          ],
        },
      ],
    }
  }

  const handleApiLoaded = map => {
    map.addListener( "bounds_changed", function () {
      const zoom = map.getZoom()
      const loadFeatures = zoom > 17

      if ( loadFeatures ) {
        // Zoom level is high enough
        var ne = map.getBounds().getNorthEast()
        var sw = map.getBounds().getSouthWest()

        // Call the what3words Grid API to obtain the grid squares within the current visble bounding box
        window.what3words.api
          .gridSectionGeoJson( {
            southwest: {
              lat: sw.lat(),
              lng: sw.lng(),
            },
            northeast: {
              lat: ne.lat(),
              lng: ne.lng(),
            },
          } )
          .then( function ( data ) {
            if ( gridData !== undefined ) {
              for ( var i = 0; i < gridData.length; i++ ) {
                map.data.remove( gridData[ i ] )
              }
            }
            gridData = map.data.addGeoJson( data )
          } )
          .catch( console.error )
      }

      // Set the grid display style
      map.data.setStyle( {
        visible: loadFeatures,
        strokeColor: "#666",
        strokeWeight: 0.25,
        clickable: false,
      } )
    } )
  }

  const _onClick = obj => {
    setCenter( { lat: obj.lat, lng: obj.lng } )
  }

  return (
    <div style={ { height: "100%", width: "100%" } }>
      <GoogleMap
        bootstrapURLKeys={ {
          key: process.env.GATSBY_GOOGLE_MAPS_API_KEY,
          libraries: [ "places", "geometry", "drawing", "visualization" ],
        } }
        yesIWantToUseGoogleMapApiInternals={ true }
        onGoogleApiLoaded={ ( { map, maps, what3words } ) =>
          handleApiLoaded( map, maps, what3words )
        }
        zoom={ zoom }
        center={ center }
        options={ createMapOptions }
        onClick={ _onClick }
      >
        <Marker lat={ center.lat } lng={ center.lng } />
      </GoogleMap>
    </div>
  )
}

export default GoogleMapEL
